import {
  HorseBodyPartType,
  AsymmetryLimbType,
  AsymmetryMeanVariableType,
} from '../../types/asymmetry-type';

export interface SeveritiesText {
  sound: string;
  veryMild: string;
  mild: string;
  moderate: string;
  severe: string;
}

export interface LanguagesText {
  en: SeveritiesText;
}

export interface AnalysisResultsTextCommon {
  id: string;
  body: HorseBodyPartType;
  limb: AsymmetryLimbType;
  variable: AsymmetryMeanVariableType;
  text: LanguagesText;
}

// Interface implementations start

export class SeveritiesTextClass implements SeveritiesText {
  sound: string;
  veryMild: string;
  mild: string;
  moderate: string;
  severe: string;

  constructor(o: any = {}) {
    this.sound = o['sound'] ?? null;
    this.veryMild = o['veryMild'] ?? null;
    this.mild = o['mild'] ?? null;
    this.moderate = o['moderate'] ?? null;
    this.severe = o['severe'] ?? null;
  }
}

export class LanguagesTextClass implements LanguagesText {
  en: SeveritiesText;

  constructor(o: any = {}) {
    this.en = new SeveritiesTextClass(o['en']);
  }
}

export class AnalysisResultsTextCommonClass
  implements AnalysisResultsTextCommon
{
  id: string;
  body: HorseBodyPartType;
  limb: AsymmetryLimbType;
  variable: AsymmetryMeanVariableType;
  text: LanguagesText;

  constructor(o: any = {}) {
    this.id = o['id'] ?? null;
    this.body = o['body'] ?? null;
    this.limb = o['limb'] ?? null;
    this.variable = o['variable'] ?? null;
    this.text = o['text'] ?? null;
  }
}
